import { render, staticRenderFns } from "./ContractForm.vue?vue&type=template&id=50071fb6&scoped=true&"
import script from "./ContractForm.vue?vue&type=script&lang=js&"
export * from "./ContractForm.vue?vue&type=script&lang=js&"
import style0 from "./ContractForm.vue?vue&type=style&index=0&id=50071fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50071fb6",
  null
  
)

export default component.exports